document.addEventListener('DOMContentLoaded', () => {
  const mobileBreakpoint = 850;

  function isMobile() {
    return window.innerWidth < mobileBreakpoint;
  }

  // Get current URL path
  const path = window.location.pathname;

  // Only proceed if URL contains 'checkout' 
  if (!path.includes('checkout')) {
    return;  // Exit early: disable toggle on other pages
  }

  const siteNav = document.querySelector('.site-nav');
  if (!siteNav) return;

  const topLevelCollectionsLink = [...siteNav.children].find(el =>
    el.tagName === 'A' && el.getAttribute('href') === '/'
  );
  if (!topLevelCollectionsLink) return;

  function getSubmenuItems() {
    const submenuItems = [];
    let sibling = topLevelCollectionsLink.nextElementSibling;
    while (sibling && sibling.tagName === 'A' && sibling.getAttribute('href') !== '/pages/ss25-about') {
      submenuItems.push(sibling);
      sibling = sibling.nextElementSibling;
    }
    return submenuItems;
  }

  let submenuVisible = false;

  topLevelCollectionsLink.addEventListener('click', (e) => {
    if (!isMobile()) return;

    if (e.currentTarget !== topLevelCollectionsLink) {
      return;
    }

    e.preventDefault();

    const submenuItems = getSubmenuItems();

    if (!submenuVisible) {
      submenuItems.forEach(link => link.style.display = 'block');
      siteNav.classList.add('open');
      topLevelCollectionsLink.classList.add('open');
      submenuVisible = true;
    } else {
      submenuItems.forEach(link => link.style.display = 'none');
      siteNav.classList.remove('open');
      topLevelCollectionsLink.classList.remove('open');
      submenuVisible = false;
    }
  });

  // Hide submenu by default on mobile load
  if (isMobile()) {
    getSubmenuItems().forEach(link => link.style.display = 'none');
  }

  // Close submenu when clicking outside
  document.addEventListener('click', (e) => {
    if (!isMobile()) return;
    if (!siteNav.contains(e.target)) {
      getSubmenuItems().forEach(link => link.style.display = 'none');
      siteNav.classList.remove('open');
      topLevelCollectionsLink.classList.remove('open');
      submenuVisible = false;
    }
  });

  // Reset on window resize
  window.addEventListener('resize', () => {
    if (!isMobile()) {
      getSubmenuItems().forEach(link => link.style.display = '');
      siteNav.classList.remove('open');
      topLevelCollectionsLink.classList.remove('open');
      submenuVisible = false;
    } else {
      getSubmenuItems().forEach(link => link.style.display = 'none');
    }
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const siteNav = document.querySelector('.site-nav');
  if (!siteNav) return;

  const productsParentLink = siteNav.querySelector('a.parent-active');

  if (!productsParentLink) return;

  const childLinks = productsParentLink.nextElementSibling?.querySelectorAll('a') || [];

  // If any child is active, mark parent active too (but don't open dropdown automatically)
  const childActive = Array.from(childLinks).some(link => link.classList.contains('active'));
  if (childActive) {
    productsParentLink.classList.add('active');
  } else {
    productsParentLink.classList.remove('active');
  }

  // Toggle dropdown open/close on clicking the Products link
  productsParentLink.addEventListener('click', (e) => {
    e.preventDefault();  // prevent navigation if Products has href

    siteNav.classList.toggle('open');
  });

  // Optional: close dropdown if clicking outside nav (mobile-friendly)
  document.addEventListener('click', (e) => {
    if (!siteNav.contains(e.target)) {
      siteNav.classList.remove('open');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const siteNav = document.querySelector('.site-nav');
  const emptyTab = document.querySelector('.empty_tab_product');
  const path = window.location.pathname;

  if (!siteNav || !emptyTab) return;

  function isMobile() {
    return window.innerWidth < 850;
  }

  function updateEmptyTabVisibility() {
    // Only show if on /products/ AND on mobile
    if (path.includes('/products/') && isMobile()) {
      emptyTab.style.display = 'block'; // Overrides the CSS !important
    }
  }

  // Initial check
  updateEmptyTabVisibility();

  // Re-check on resize
  window.addEventListener('resize', updateEmptyTabVisibility);

  // Toggle dropdown when clicked
  emptyTab.addEventListener('click', (e) => {
    e.preventDefault();
    if (isMobile()) {
      siteNav.classList.toggle('open');
    }
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', (e) => {
    if (isMobile() && !siteNav.contains(e.target)) {
      siteNav.classList.remove('open');
    }
  });
});


  // JS for intro-overlay

document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.querySelector("idle-overlay");
  const form = document.getElementById("comingSoonForm");

  if (!overlay || !form) return;

  const button = form.querySelector("button");
  const input = form.querySelector("input");

  const STORAGE_KEY = "frizbee_coming_soon";
  const THREE_HOURS = 3 * 60 * 60 * 1000;
  const now = Date.now();

  const saved = localStorage.getItem(STORAGE_KEY);
  const isThemeEditor = window.Shopify && Shopify.designMode;

  /* ---------- SKIP OVERLAY LOGIC ---------- */
  if (!isThemeEditor && saved && now - Number(saved) < THREE_HOURS) {
    overlay.remove();
    document.body.classList.remove("idle-locked");
    return;
  }

  /* ---------- SHOW OVERLAY ---------- */
  overlay.style.display = "block";
  overlay.style.opacity = "1";
  overlay.style.visibility = "visible";
  document.body.classList.add("idle-locked");

  /* ---------- FORM SUBMIT ---------- */
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    if (button.disabled) return;

    const email = input.value;

    // Visual feedback
    button.textContent = "THANK YOU";
    button.disabled = true;
    input.disabled = true;

    // Save to Shopify
    fetch("/contact", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        "contact[email]": email,
        "contact[tags]": "collections-2026"
      })
    });

    // Save to Google Sheets via Make
    fetch("https://hook.eu2.make.com/svhcsynoeo45nkfv8vmibn7hm4n1jphi", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: email,
        source: "frizbee-ceramics-collection-2026-overlay",
        page_url: window.location.href,
        timestamp: new Date().toISOString()
      })
    });

    // Remember submission time
    localStorage.setItem(STORAGE_KEY, Date.now());

    // Fade out overlay
    setTimeout(() => {
      overlay.style.transition = "opacity 0.2s ease";
      overlay.style.opacity = "0";

      setTimeout(() => {
        overlay.remove();
        document.body.classList.remove("idle-locked");
      }, 200);
    }, 300);
  });
});

